<template xmlns="http://www.w3.org/1999/html">
  <div class="page">
    <div class="d-flex justify-content-between align-items-center p-3">
<!--      <h3 style="font-size: 30px">Wallet Request History</h3>-->
      <div>
        <select v-model="selectedWallet"  @change="storeSelectedWallet" class="form-select">
          <option value="" disabled>Select Wallet</option>
          <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">
            {{ wallet.wallet_name }}
          </option>
        </select>
      </div>
    </div>
    <RangeSelector :submit-method="updateColumns" />
    <div class="header">
      <div class="filter">
        <div class="radio-inputs">
          <label class="radio">
            <input type="radio" name="radio" id="pending" value="PENDING" v-model="status" @change="updateColumns"/>
            <span class="name">Pending</span>
          </label>
          <label class="radio">
            <input type="radio" name="radio" checked="" id="approved" value="APPROVED" v-model="status" @change="updateColumns"/>
            <span class="name">Approved</span>
          </label>
          <label class="radio">
            <input type="radio" name="radio" id="denied" value="DENIED" v-model="status" @change="updateColumns"/>
            <span class="name">Denied</span>
          </label>
        </div>
        <div class="filter" style="width: fit-content">
          <ApproveButton
              style="margin-right: 5px"
              buttonText="Filter"
              @click="showFilterModal"
          />
        </div>
      </div>
    </div>

    <div class="request-container">
      <vue-good-table
          style="width: 99%; margin: auto;"
          :columns="filteredColumns"
          :rows="rows"
          theme="black-rhino"
          :search-options="{
            enabled: true,
            placeholder: 'Search A Request',
            skipDiacritics: true
          }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'amount'">
            <span class="fw-bold">{{ $utils.formatMoney(props.row.amount) }}</span>
          </span>

          <!-- Display From Wallet -->
          <span v-else-if="props.column.field === 'from_wallet'">
            {{ formatWallet(props.row.from_wallet) }} =>
          </span>

          <!-- Display To Wallet -->
          <span v-else-if="props.column.field === 'to_wallet'">
            {{ formatWallet(props.row.to_wallet) }}
          </span>
<!--          <span v-else-if="props.column.field === 'choice'">-->
<!--            <div class="button-container">-->
<!--              <button type="button" class="accept-button" @click="confirmAccept(props.row)">View</button>-->
<!--              <button type="button" class="delete-button" @click="confirmDeny(props.row)">Deny</button>-->
<!--            </div>-->
<!--          </span>-->
        </template>
      </vue-good-table>
    </div>
    <div v-if="filterModal" class="modal-overlay">
      <div class="modal-content form-container">
        <div class="modal-header" >
          <h3>Select Your Search Parameters</h3>
        </div>
        <div class="modal-bodyy">
          <div class="filter">
            <select
                class="form-select"
                id="floatingSelect"
                aria-label="Floating label select example"
                v-model="selectedRole"
            >
              <option disabled value="" style="margin-top: 10px">Select Role</option>
              <option
                  v-for="role in roles"
                  :key="role.id"
                  :value="role.name"
              >
                {{ role.name }}
              </option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedOffice"
            >
              <option disabled value="" style="margin-top: 10px">Select Office</option>
              <option v-for="dept in allOffices" :key="dept.id" :value="dept.id">
                {{ dept.name }}
              </option>
            </select>
            <select
                v-model="selectedStatus"
                class="form-select"
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="archived">Archived</option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedUsers"
            >
              <option disabled value="" style="margin-top: 10px">Select User</option>
              <option v-for="user in filteredUsers" :key="user.id" :value="user.Username">
                {{ user.Username }}
              </option>
            </select>
          </div>
          <div class="filter">
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedFromWallet"
            >
              <option disabled value="" style="margin-top: 10px">Select from wallet</option>
              <option v-for="wallet in wallets2" :key="wallet.id" :value="wallet.id">
                {{ wallet.wallet_name }}
              </option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedToWallet"
            >
              <option disabled value="" style="margin-top: 10px">Select to wallet</option>
              <option v-for="wallet in wallets2" :key="wallet.id" :value="wallet.id">
                {{ wallet.wallet_name }}
              </option>
            </select>
            <input
                placeholder="Reason"
                style="width: 100%; height: 35px"
                v-model="reason"
            />
          </div>
        </div>
        <div class="flexy">
          <ApproveButton
              buttonText="Search"
              hoverTextColor="#ffffff"
              @click="searchFilteredRequests"
          />
          <ApproveButton
              buttonText="Close"
              buttonColor="black"
              hoverColor="#c82333"
              hoverTextColor="#ffffff"
              @click="closeFilterModal"
          />
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>
    <MakeWalletRequest :selectedWallet="selectedWallet" :wallets="wallets"/>
  </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';
import {tableMixin} from "@/mixins/tableMixin";
import RangeSelector from "@/components/layout/RangeSelector.vue";
import axios from 'axios';
import {Storage} from "@/Services/Storage";
import {v4 as uuidv4} from 'uuid';
import Swal from "sweetalert2";
import MakeWalletRequest from "@/views/MakeWalletRequest.vue";
import ApproveButton from "@/components/buttons/ApproveButton.vue";

export default {
  name: "wallet",
  mixins: [tableMixin],
  components: {
    ApproveButton,
    MakeWalletRequest,
    RangeSelector,
    VueGoodTable
  },
  data() {
    return {
      isLoading: false,
      reason: '',
      selectedUsers: '',
      selectedRole: '',
      roles: '',
      selectedOffice: "",
      selectedStatus: "active",
      allUsers: '',
      allOffices: '',
      filterModal: false,
      columns: [
        { label: 'Requested By', field: 'request_by' },
        { label: 'Amount', field: 'amount', type: 'number' },
        { label: 'Reason', field: 'reason',},
        { label: 'Processed by', field: 'processed_by' },
        { label: 'From Wallet', field: 'from_wallet' },
        { label: 'To Wallet', field: 'to_wallet' },
        { label: 'Date', field: 'request_date' },
        { label: 'Decline Reason', field: 'declined_reason' },
        { label: 'status', field: 'status' },
        { label: 'Act', field: 'choice' },
       ],
      rows: [],
      formData: {},
      user: {
        Username: 'Null',
        id: 'Null',
        wallets: [],
        office: ''
      },
      wallets: [],
      sendWallet: '',
      selectedWallet: '',
      wallets2: [],
      status: 'APPROVED',
      uuid: generateUUID(),
      selectedToWallet: '',
      selectedFromWallet: '',

    };
  },
  created() {
    this.getRoles();
    this.getAllUsers();
    this.getOffices();
    this.getWallets();
  },
  computed: {
    filteredUsers() {
      if (!Array.isArray(this.allUsers)) return []; // Ensure it's an array before filtering

      return this.allUsers.filter((user) => {

        // Text Search Filter
        // const matchesText =
        //     user.firstName.toLowerCase().includes(this.input.toLowerCase()) ||
        //     user.lastName.toLowerCase().includes(this.input.toLowerCase()) ||
        //     user.Username.toLowerCase().includes(this.input.toLowerCase());

        // Status Filter
        const matchesStatus =
            this.selectedStatus === "all" ||
            (this.selectedStatus === "active" && !user.archived) ||
            (this.selectedStatus === "archived" && user.archived);

        // Type Filter
        const matchesType =
            !this.selectedRole || user.Type === this.selectedRole;

        const matchesOffice =
            !this.selectedOffice || user.officeID === this.selectedOffice;

        return matchesStatus && matchesType && matchesOffice;
      });
    },
    filteredColumns() {
      if (this.status === 'APPROVED') {
        return this.columns.filter(col => ['amount', 'reason', 'request_date','request_by', 'processed_by', 'from_wallet', 'to_wallet'].includes(col.field));
      } else if (this.status === 'DENIED') {
        return this.columns.filter(col => ['amount', 'reason', 'declined_reason', 'request_date', 'processed_by', 'from_wallet', 'to_wallet'].includes(col.field));
      } else {
        return this.columns.filter(col => ['amount', 'reason', 'request_date', 'request_by', 'from_wallet', 'to_wallet', 'choice'].includes(col.field));
      }
    }
  },
  beforeMount() {
    this.searchFilteredRequests();
    this.getwallets();
    this.storeSelectedWallet();
    this.getLoggedInUser();
  },
  methods: {
    formatWallet(wallet_id) {
      if (wallet_id === "1") return "Main";
      if (wallet_id === "2") return "Lusaka Wallet";
      if (wallet_id === "2") return "Chilufya Safe";
      return "Unknown"; // Default fallback
    },
    getAllUsers() {
      axios.get(`${ticketApi}user/getAll`)
          .then(response => {
            this.allUsers = response.data;
            console.log(this.allUsers);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getRoles() {
      axios.get(`${synergyApi}employee/getAllDepartments`)
          .then(response => {
            this.roles = response.data;
            console.log(this.roles);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getOffices() {
      axios.get(`${synergyApi}employee/getOffices`)
          .then(response => {
            this.allOffices = response.data;
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getWallets() {
      axios.get(`${ticketApi2}get-all-wallets?officeID=1`)
          .then(response => {
            this.wallets2 = response.data;
            console.log(this.wallets2);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    showFilterModal() {
      this.filterModal = true;
    },
    closeFilterModal() {
      this.filterModal = false;
      this.selectedOffice = '';
      this.reason = '';
      this.selectedUsers = '';
      this.selectedRole = '';
      this.selectedToWallet = '';
      this.selectedFromWallet = '';
    },
    storeSelectedWallet() {
      if (this.selectedWallet) {
        // localStorage.setItem('selectedWallet', this.selectedWallet);
        this.$store.commit(`setSelectedWallet`,this.selectedWallet)
      }
    },
    async getLoggedInUser() {
      try {
        this.user = await Storage.getCurrentUser();
        console.log('Logged-in user:', this.user);  // Add logging to verify user data
      } catch (error) {
        console.error('Error fetching logged-in user:', error);
      }
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data;
        console.log('Wallets:', this.wallets);

        // Set the first wallet as the default selected wallet
        if (this.wallets.length > 0) {
          this.selectedWallet = this.wallets[0].id;
         }
      } catch (error) {
        console.error('Error fetching wallets:', error);
      } finally {
        this.storeSelectedWallet();

        this.$utils.hideLoading();
      }
    },
    async submitincoming() {
      this.$utils.showLoading();
      try {
        const params = new URLSearchParams();
        const globalDateRange = this.$store.getters.getGlobalDateRange;
        for (const [key, value] of Object.entries(globalDateRange)) {
          params.append(key, value);
        }
        params.append('status', this.status);
        params.append('type', 'wallet');

        const response = await this.$store.dispatch('getwallets', params.toString());
        this.rows = response;
        console.log(this.rows);
      } finally {
        this.$utils.hideLoading();
      }
    },
    updateColumns() {
      this.searchFilteredRequests();
    },
    searchFilteredRequests() {
      const range = this.$store.getters.getGlobalDateRange;
      const status = this.status;
      const fromDate = range.from;
      const toDate = range.to;
      const request_by = this.selectedUsers;
      const reason = this.reason;
      const fromWallet = this.selectedFromWallet;
      const toWallet = this.selectedToWallet;
      this.isLoading = true;
      const url = `${ticketApi2}searchWalletRequests?fromDate=${fromDate}&toDate=${toDate}&request_by=${request_by}&reason=${reason}&fromWallet=${fromWallet}&toWallet=${toWallet}&status=${status}`;
      console.log(url);
      axios.get(url)
          .then(response => {
            this.rows = response.data;
            console.log('Search results:', response.data);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.closeFilterModal();
          });
    },
  }
};
</script>

<style scoped lang="scss">
.flexy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.hidden {
  display: none;
}
.page {
  height: 90vh;
  overflow-y: scroll !important;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
  justify-content: center;
}

.card {
  width: 200px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  transition: transform 0.2s;
  text-align: center;
}

.card:hover {
  transform: scale(1.05);
}

.card-img-top {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.card-body {
  padding: 1rem;
}

.card-text {
  margin: 0;
  font-weight: bold;
}

.button-container {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
}

#vgt-table td {
  text-align: center !important;
}

.accept-button,
.delete-button {
  border: none;
  padding: 8px 16px;
  margin: 5px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.accept-button {
  background-color: #28a745;
  color: white;
}

.delete-button {
  background-color: #dc3545;
  color: white;
}

.accept-button:hover,
.delete-button:hover {
  background-color: transparent;
  color: #333;
  outline: 1px solid #333;
}

.header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.radio-inputs {
  margin: 10px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #eee;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.25rem;
  width: 300px;
  font-size: 14px;
}
.radio {
  margin: 2px;
}
.radio-inputs .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 0.5rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all 0.15s ease-in-out;
}

.radio-inputs .radio input:checked + .name {
  background-color: #1d90dd;
  color: white;
  font-weight: 600;
}

/* Hover effect */
.radio-inputs .radio:hover .name {
  background-color: rgba(255, 255, 255, 0.5);
}

/* Animation */
.radio-inputs .radio input:checked + .name {
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  animation: select 0.3s ease;
}

@keyframes select {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Particles */
.radio-inputs .radio input:checked + .name::before,
.radio-inputs .radio input:checked + .name::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #3b82f6;
  opacity: 0;
  animation: particles 0.5s ease forwards;
}

.radio-inputs .radio input:checked + .name::before {
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
}

.radio-inputs .radio input:checked + .name::after {
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

@keyframes particles {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(0);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(var(--direction));
  }
}

.radio-inputs .radio input:checked + .name::before {
  --direction: -10px;
}

.radio-inputs .radio input:checked + .name::after {
  --direction: 10px;
}

.filter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.form-container {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
</style>
